import React from "react";
import { Box, Button, IconButton, Grid2 as Grid, Stack } from "@mui/material";
import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import { AddChannelItems } from "./addChannelItems";
import { AddTrendGraphs } from "./addTrendGraphs";
import PropTypes from "prop-types";
import {
  DASHBOARD_DRAWER_CONTENT_TYPE,
  DASHBOARD_ITEM_TYPE,
  DASHBOARD_TREND_GRAPH_LIST,
} from "../../constants";
import { AddLiveTrendGraphs } from "./addLiveTrendGraphs";
import { useTranslation } from "react-i18next";
import localizationKeys from "../../../../i18n/localizationKeys";

export const AddItemsBase = (props) => {
  const {
    currentVessel,
    content,
    setDrawerContent,
    selectedDashboard,
    setSelectedDashboard,
    setIsOpenLiveTrendPage,
    setIsDrawerOpen,
    setEditingLiveTrendChart,
    isLiveTrendAddonEnabled = false,
  } = props;
  const { t } = useTranslation();
  const dashboardItems = selectedDashboard?.items ?? [];
  const existingChannelValues = dashboardItems
    .filter((e) => e.type === DASHBOARD_ITEM_TYPE.VALUE)
    .map((e) => e.chNos[0]);
  const existingTrendGraphIds = dashboardItems
    .filter((e) => DASHBOARD_TREND_GRAPH_LIST.includes(e.type))
    .map((e) => e?.chartId ?? "");
  const existingLiveTrendGraphs = dashboardItems.filter((e) => e.type === DASHBOARD_ITEM_TYPE.LIVE);
  switch (content) {
    case DASHBOARD_DRAWER_CONTENT_TYPE.CHANNELS:
      return (
        <Box sx={{ height: "100%" }}>
          <IconButton
            sx={{ color: "white" }}
            onClick={() => {
              setDrawerContent();
            }}
          >
            <ArrowBackIcon />
          </IconButton>
          <AddChannelItems
            setSelectedDashboard={setSelectedDashboard}
            existingChannelValues={existingChannelValues}
          />
        </Box>
      );
    case DASHBOARD_DRAWER_CONTENT_TYPE.TRENDS:
      return (
        <Box sx={{ height: "100%" }}>
          <IconButton
            sx={{ color: "white" }}
            onClick={() => {
              setDrawerContent();
            }}
          >
            <ArrowBackIcon />
          </IconButton>
          <AddTrendGraphs
            currentVessel={currentVessel}
            selectedDashboard={selectedDashboard}
            setSelectedDashboard={setSelectedDashboard}
            existingTrendGraphIds={existingTrendGraphIds}
          />
        </Box>
      );
    case DASHBOARD_DRAWER_CONTENT_TYPE.LIVE_TRENDS:
      return (
        <Box sx={{ height: "100%" }}>
          <IconButton
            sx={{ color: "white" }}
            onClick={() => {
              setDrawerContent();
            }}
          >
            <ArrowBackIcon />
          </IconButton>
          <AddLiveTrendGraphs
            currentVessel={currentVessel}
            selectedDashboard={selectedDashboard}
            setSelectedDashboard={setSelectedDashboard}
            existingLiveTrendGraphs={existingLiveTrendGraphs}
            setIsOpenLiveTrendPage={setIsOpenLiveTrendPage}
            setIsDrawerOpen={setIsDrawerOpen}
            setEditingLiveTrendChart={setEditingLiveTrendChart}
          />
        </Box>
      );
    default:
      return (
        <Grid container sx={{ padding: "24px 12px", color: "#fff" }} direction={"column"} gap={"24px"}>
          <Grid item>
            {t(localizationKeys.DashboardEditDrawerAddWidgetText)}
          </Grid>
          <Grid item>
            <Stack>
            <Button
              sx={{ textTransform: "none" }}
              onClick={() => {
                setDrawerContent(DASHBOARD_DRAWER_CONTENT_TYPE.CHANNELS);
              }}
            >
              {t(localizationKeys.DashboardEditDrawerAddChannelsButtonText)}
            </Button>
            <Button
              sx={{ textTransform: "none" }}
              onClick={() => {
                setDrawerContent(DASHBOARD_DRAWER_CONTENT_TYPE.TRENDS);
              }}
            >
              {t(localizationKeys.DashboardEditDrawerAddTrendsButtonText)}
            </Button>
            {isLiveTrendAddonEnabled && (
              <Button
                sx={{ textTransform: "none" }}
                onClick={() => {
                  setDrawerContent(DASHBOARD_DRAWER_CONTENT_TYPE.LIVE_TRENDS);
                }}
              >
                {t(localizationKeys.DashboardEditDrawerAddLiveTrendsButtonText)}
              </Button>
            )}
            </Stack>
          </Grid>
        </Grid>
      );
  }
};

AddItemsBase.propTypes = {
  currentVessel: PropTypes.object,
  content: PropTypes.string,
  setDrawerContent: PropTypes.func,
  selectedDashboard: PropTypes.object,
  setSelectedDashboard: PropTypes.func,
  setIsOpenLiveTrendPage: PropTypes.func,
  setIsDrawerOpen: PropTypes.func,
  setEditingLiveTrendChart: PropTypes.func,
  isLiveTrendAddonEnabled: PropTypes.bool,
};
